import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setSentryRouteContext } from '../../utils/sentry';

const SentryRouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        setSentryRouteContext(location.pathname);
    }, [location.pathname]);

    return null;
};

export default SentryRouteTracker;
